/**
 * UserDetailModal Helpers
 * 사용자 상세 모달 관련 상수 및 헬퍼 함수
 */
import { User, UpdateUserRequestDto, CreateUserRequestDto } from '../types/user.types';
import { PRM_CODE, USE_YN } from '../../shared/config/system.config';

// ======== 타입 ========

export interface UserDetailModalProps {
    user: User | null;
    prmCodes: { comCode: string; comCdName: string }[];
    mode?: 'create' | 'edit';
    onClose: () => void;
    onUpdate?: (userId: string, request: UpdateUserRequestDto) => Promise<void>;
    onCreate?: (request: CreateUserRequestDto) => Promise<void>;
}

export type FormDataType = CreateUserRequestDto | UpdateUserRequestDto;

// ======== 상수 ========

export const TOAST_MESSAGES = {
    REQUIRED_FIELDS: '필수 항목을 모두 입력해주세요.',
} as const;

export const MODAL_TITLES = {
    CREATE: '사용자 등록',
    EDIT: '사용자 상세 정보',
} as const;

export const BUTTON_LABELS = {
    CANCEL: '취소',
    SAVE: '저장',
    SAVING: '저장 중...',
} as const;

export const FORM_LABELS = {
    USER_ID: '사용자 ID',
    USER_NAME: '사용자명',
    PERMISSION: '권한',
    USE_YN: '사용 여부',
    PHONE: '전화번호',
    EMAIL: '이메일',
} as const;

export const INFO_LABELS = {
    SECTION_TITLE: '등록 정보',
    INS_USER: '등록자:',
    INS_DATE: '등록일시:',
    UPD_USER: '수정자:',
    UPD_DATE: '수정일시:',
} as const;

export const USE_YN_OPTIONS = [
    { value: USE_YN.YES, label: '사용' },
    { value: USE_YN.NO, label: '미사용' },
] as const;

// ======== 초기값 ========

/**
 * 생성 모드 폼 초기값
 */
export const getCreateModeInitialData = (): CreateUserRequestDto => ({
    userId: '',
    userName: '',
    prmCode: PRM_CODE.HEAD,
    phoneNum: '',
    emailInfo: '',
    useYn: USE_YN.YES,
});

/**
 * 수정 모드 폼 초기값 (사용자 정보 기반)
 */
export const getEditModeInitialData = (user: User): UpdateUserRequestDto => ({
    userId: user.userId,
    userName: user.userName,
    prmCode: user.prmCode,
    phoneNum: user.phoneNum,
    emailInfo: user.emailInfo || '',
    useYn: user.useYn,
    suppType: user.suppType || 'D',
});

// ======== 유효성 검사 ========

/**
 * 생성 모드 필수 필드 검증
 */
export const validateCreateForm = (formData: CreateUserRequestDto): boolean => {
    const { userId, userName, prmCode, phoneNum, emailInfo } = formData;
    return !!(userId && userName && prmCode && phoneNum && emailInfo);
};

// ======== 헬퍼 함수 ========

/**
 * 전화번호 입력값에서 숫자만 추출
 */
export const extractPhoneNumbers = (value: string): string => {
    return value.replace(/\D/g, '');
};

export { displayValue } from './userManagement.helpers';
